<template>
  <v-app>
    <v-navigation-drawer class="primary lighten-2 white--text" v-model="drawer" temporary absolute>
      <v-list active-class="blue--text" class="primary lighten-2 white--text">
        <v-list-tile active-class="blue--text" v-for="item in menuItems" :key="item.title" :to="item.link">
          <v-list-tile-action>
            <v-icon class="white--text">{{item.icon}}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{item.title}}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="isAuthenticated" @click="userSignOut">
          <v-list-tile-action>
            <v-icon color="white">exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>Kilép</v-list-tile-content>
        </v-list-tile>
      </v-list>      
    </v-navigation-drawer>
    <v-toolbar color="primary" class="white--text elevation-10 lighten-1">
      <v-btn flat fab @click.stop="drawer = !drawer" class="hidden-md-and-up white--text"><v-toolbar-side-icon class="white--text"></v-toolbar-side-icon></v-btn>
      <v-toolbar-title class="white--text">
        <router-link to="/" tag="span" style="cursor: pointer">{{ this.appTitle }}</router-link>
      </v-toolbar-title>      
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down white--text">
        <v-btn class="white--text" flat v-for="item in menuItems" :key="item.title" :to="item.link">
          <v-icon left class="white--text">{{item.icon}}</v-icon>
          {{item.title}}</v-btn>
          <v-btn class="white--text" flat v-if="isAuthenticated" @click="userSignOut">
            <v-icon >exit_to_app</v-icon>Kilép
          </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-content class="primary lighten-3">
      <router-view/>
    </v-content>
     <footer>
       <cookie-law theme="dark-lime" 
       buttonText="Elfogadom"
       message="A MOEX süti (cookie) fájlokat használ. Ezeket a fájlokat az Ön gépén tárolja a rendszer. A cookie-k személyek azonosítására nem alkalmasak, szolgáltatásaink biztosításához szükségesek. Az oldal használatával Ön beleegyezik a cookie-k használatába."></cookie-law>
    </footer>
  </v-app>
</template>

<script>
import CookieLaw from 'vue-cookie-law'
export default {
  data () {
    return {
      drawer: null
    }
  },
  name: 'App',
  methods: {
    userSignOut () {
      this.$store.dispatch('userSignOut')
    }
  },
  components: { CookieLaw },
  computed: {
    appTitle () {
      return this.$store.state.appTitle
    },
    menuItems () {
      let menuItems = [
        { icon: 'home' , title: 'Főoldal', link: '/'},
        { icon: 'account_box' , title: 'Bejelentkezés', link: '/login'},
        { icon: 'person_add' , title: 'Regisztráció', link: '/signup'}
      ]
      if (this.isAuthenticated) {
        menuItems = [
        { icon: 'home' , title: 'Főoldal', link: '/home'},
        { icon: 'reorder' , title: 'Riportok', link: '/reports'},        
        { icon: 'group' , title: 'Csoport(ok)', link: '/group'},        
        { icon: 'account_box' , title: 'Profil', link: '/profile'},
        ]
      }
      return menuItems
    },
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue